var __symbolPrefix = "3r/message-api/helpers/"

function hasCategory (_, getParameterByName, isMessageVisible, category) {
    category = (category || '').toLowerCase()
    return function (message) {
        if (!message) return false
        message = message.message || message
        message.categories = message.categories || {}

        if (message.categories['development'] && !getParameterByName('developer')) return false
        if (message.categories['testing'] && !getParameterByName('tester')) return false
        if (message.categories.apponly && !getParameterByName('app')) return false
        if (message.categories.webonly && getParameterByName('app')) return false
        if (category) {
            if (!_(category.split('&&'))
                    .every(function (group) {
                        return _(group.split('||'))
                            .some(function (c) {
                                return message.categories[c.trim()]
                            })
                    })) {
                return false
            }
        }

        return isMessageVisible(message)
    }
}

hasCategory._depends = {
    symbol : __symbolPrefix + "hasCategory",
    modules : [
        "_",
        "3r/getParameterByName",
        "3r/message-api/helpers/isMessageVisible"
    ]
}

function groupsFromSchemeMessages(hasCategory, schemeSettings, available) {
    let listOfGroups = schemeSettings.messageGroups || []
    let groups = listOfGroups.map(group => {
        group.messages = group.category ? available.filter(hasCategory(group.category)) : []
        return group
    })
    return groups
        .filter(group => (group.items && group.items.length) || (group.messages && group.messages.length))
}

groupsFromSchemeMessages._depends = {
    symbol : __symbolPrefix + "groupsFromSchemeMessages",
    modules : [
        __symbolPrefix + "hasCategory",
        "3r/schemeSettings/webapp"
    ]
}

function groupIncludesMessage(group, message) {
    
    if (group.messages && typeof group.messages.map == "function") {
        var groupMessageIds = group.messages.map(function (msg) { return msg.id }) 
        
        if (groupMessageIds.indexOf(message.id) >= 0) {
            return true
        }
    }
    
    if (group.items && typeof group.items.filter == "function") {
        return group.items
            .filter(function (g) { return g.type == "group"})
            .some(function (g) { return groupIncludesMessage(g, message) }) 
    }
    
    return false
}
groupIncludesMessage._depends = {
    symbol : __symbolPrefix + "groupIncludesMessage",
    modules : [
    ]
}

function rejectMessagesWithGroup(groups) {
    return function (message) {
        return !groups.some(function (group) { return groupIncludesMessage(group, message) ;}) 
    }
}
rejectMessagesWithGroup._depends = {
    symbol : __symbolPrefix + "rejectMessagesWithGroup",
    modules : [
    ]
}

function passMessagesForHomepage (groups) {
    var excludeGrouped = rejectMessagesWithGroup(groups)
    return function (message) {
        return excludeGrouped(message) && !message.hideOnHomePage
    }
}
passMessagesForHomepage._depends = {
    symbol : __symbolPrefix + "passMessagesForHomepage",
    modules : [
    ]
}

function sortAndDedupeForHomepage (_, available) {
    return _(available).sortBy(function (a) {
        return a.id
    }).sortBy(function (a) {
        return -(a.priority || 100)
    }).uniq('id').filter(function (a) {
        return a && !a.categories || !a.categories.hideonhome
    }).value()
}
sortAndDedupeForHomepage._depends = {
    symbol : __symbolPrefix + "sortAndDedupeForHomepage",
    modules : [
        "_"
    ]
}

function partitionHomepageMessages(_, schemeSettings, list) {
    let numFirstRow = +(schemeSettings.globals.homePageFirstRow || 1)
    let numSecondRow = +(schemeSettings.globals.homePageSecondRow || 3)
    let numRemainder = +(schemeSettings.globals.homePageRemainder || 8)

    let result = { firstItems : [], items : [], headline : []} 

    result.firstItems = _.take(_.slice(list, numFirstRow), numSecondRow)
    result.items = _.take(_.slice(list, numFirstRow + numSecondRow), numRemainder)
    result.headline = _.take(list, numFirstRow)

    return result
}
partitionHomepageMessages._depends = {
    symbol : __symbolPrefix + "partitionHomepageMessages",
    modules : [
        "_",
        "3r/schemeSettings/webapp"
    ]
}

function initMapToType () {
    return {
        lookup: {},
        lookupById: {},
        all: []
    }
}

initMapToType._depends = {
    symbol : __symbolPrefix + "initMapToType",
    modules : []
}

function getMessageButtons(_,Device,Promise,getButtons,message){
    if (message.quantities.buttonStaticLookup) {
        let buttonLookup = message.quantities.buttonStaticLookup
        let buttonLookupKey = message.quantities.buttonStaticLookupKey
        let buttonKey = message.systemId
        let hasKey = true

        switch (buttonLookupKey) {
            case "origin":
                buttonKey = message.ATTRIBUTES.origin
                break

            case "userId":
                buttonKey = Device.permanentId
                break

            case "static":
                hasKey = false
                break
        }

        if (hasKey && !buttonKey && ["boolean", "number"].indexOf(typeof key) < 0) {
            return Promise.resolve(getButtons(message.quantities.buttons))
        } else {
            return Device.gtp("/static-lookup/rows/" + Device.schemeId + "/" + buttonLookup + (hasKey ? "/" + buttonKey : ""))
                .then(function(results) {
                    let rows = (results.rows || [])
                    let validActions = rows.map(function(row) { return row[1] })
                    return getButtons(message.quantities.buttons, validActions)
                })
        }
    } else {
        return Promise.resolve(getButtons(message.quantities.buttons))
    }
}

getMessageButtons._depends = {
    symbol : __symbolPrefix + "getMessageButtons",
    modules : [
        "_",
        "3r/Device",
        "Promise",
        __symbolPrefix + "getButtons"
    ]
}

function getButtons(_, embedMessageContent, buttons, validActions) {
    return _.map(buttons, function(b) {
        if (!b.items && b.value.trim().substr(0, 1) == '{') {
            b.items = JSON.parse(b.value)

            if (validActions && typeof validActions.indexOf == "function") {
                b.items.items = ((b.items || {}).items || []).filter(function(item) {
                    return validActions.indexOf(item.action) >= 0
                })
            }

            ((b.items).items || []).forEach(function(item) {
                item.label = item.label || item.action
            })

            b.value = ''
        }

        if ((b.items || {}).items && typeof b.items.items.filter == "function" && validActions && typeof validActions.indexOf == "function") {
            if (!b.items.originalItems) {
                b.items.originalItems = b.items.items.slice()
            }

            b.items.items = b.items.originalItems.filter(function(item) {
                return validActions.indexOf(item.action) >= 0
            })
        }

        return b
    }).filter(function(b) {
        if ((b.items || {}).items) {
            return b.items.items.length
        } else if (validActions && typeof validActions.indexOf == "function") {
            return validActions.indexOf(b.action || b.value) >= 0
        } else {
            return true
        }
    }).map(function(b) {
        if(b.hyperlink && b.hyperlink.url) {
            b.hyperlink.parsedUrl = embedMessageContent(b.hyperlink.url)
        }
        
        return b
    })
}

getButtons._depends = {
    symbol : __symbolPrefix + "getButtons",
    modules : [
        "_",
        "3r/message-api/content/embedMessageContent"
    ]
}

async function press(spendPoints, pressButton, detectLocation, closeMessage, message, button) {
    let buttonDefinition = {
        message : message,
        button : message.quantities.buttons.indexOf(button),
        value : button.value.action || button.value,
        redeem : button.redeem
    }

    let close = closeOptions(button)

    if (close == "before" && closeMessage) {
        await closeMessage(message) 
    }

    let result

    if (button.cost) {
        result = await spendPoints(button.cost, message.systemId, buttonDefinition) 
    } else {
        result = await pressButton(buttonDefinition)
    }
    
    if (close == "after" && closeMessage) {
        await closeMessage(message) 
    }

    return result
}
press._depends = {
    symbol : __symbolPrefix + "press",
    modules : [
        __symbolPrefix + "spendPoints",
        __symbolPrefix + "pressButton"
    ]
}

function closeOptions(button) { 
    var close

    if (!button.close) {
        return false
    }

    close = button.close.toString()

    if (close == "false") {
        return false
    } else if (close == "before") {
        return "before"
    } else {
        /* Previous / default behaviour is the close the popup after
         * the button actions have been performed.
         */
        return "after"
    }
}

function tacticCommands(openTactic) {
    return function (command) {
        let parts = command.split(':')
        if (parts.length < 2) return
        switch (parts[0].toLowerCase()) {
            case 'open':
                openTactic(+parts[1])
                break
        }
    }
}

async function pressButton(Device, lang, tacticCommands, spendInfo) { 
    console.log({lang, tacticCommands, spendInfo})
    
    await Device.trigger("buttonPress", {
        messageId: spendInfo.message.systemId,
        buttonId: spendInfo.button,
        value: spendInfo.value
    })
    
    let result = await Device.gtp('/pressbutton/:uid/:messageid/:buttonid', {
        messageid: spendInfo.message.systemId,
        buttonid: spendInfo.button,
        value: spendInfo.value
    })
    
    if ((result || {}).success) {
        if (tacticCommands) {
            tacticCommands(spendInfo.value)
        }

        if(spendInfo.redeem) {
            await Device.redeemed(spendInfo.message)
        }
        
        await Device.unlock('WM.Ack', spendInfo.message.systemId)
        await Device.getInfo(true)
        return result

    } else {
        let error = null

        if ((result || {}).isLimitError) {
            error = new Error(lang("You are too late, no inventory remaining.", "Spend Points")) 
            error.isLimitError = true
            error.messageForUser = true

        } else {
            error = new Error(lang("Not enough Spend Points", "Spend Points"))
            error.messageForUser = true
        }

        throw error
    }
}

pressButton._depends = {
    symbol : __symbolPrefix + "pressButton",
    modules : [
        "3r/Device",
        __symbolPrefix + "language",
        {
            symbol : "3r/tacticCommands",
            nullIfMissing : true
        }
    ]
}

async function spendPoints(_, Device, actionbar, lang, pressButton, points, reason, doSpend) {
    points = +(points||0)

    if (!doSpend) {
        return
    }

    if(isNaN(points) || points == 0) {
        return await pressButton(doSpend)
    }

    let radicalPoints = +_.get(Device, "info.user.ATTRIBUTES.radicalPoints", 0)

    if (points > radicalPoints) {
        let error = null
        error = new Error(lang("Not enough Spend Points", "Spend Points"))
        error.messageForUser = true
        throw error
    }

    let value = null

    if (actionbar) {
        value = await actionbar(
            [
                {
                    "caption": lang("Spend", "Spend Points") + " " + points + " " + lang(
                        "points",
                        "Spend Points"),
                    "id": 1
                }
            ],
            true,
            {
                title: lang("You must spend", "Spend Points") + " " + lang("points", "Spend Points") + " " + lang("to proceed", "Spend Points")
            }
        )
    } else {
        value = { id : 1 }
    }

    if (value.id == 1) {
        return pressButton(doSpend)
    }
}

spendPoints._depends = {
    symbol : __symbolPrefix + "spendPoints",
    modules : [
        "_",
        "3r/Device",
        {
            symbol : "3r/actionbar",
            nullIfMissing : true
        },
        __symbolPrefix + "language",
        __symbolPrefix + "pressButton"
    ]
}

function language(schemeSettings, configuration, text, section) {
    if (configuration) {
        return configuration(text, section)
    } else {
        return text
    }
}

language._depends = {
    symbol : __symbolPrefix + "language",
    modules : [
        "3r/schemeSettings/webapp",
        {
            symbol : "3r/configuration",
            nullIfMissing : true
        }
    ]
}

function filterShowInMenuMessages (_, all) {
    return _(all).filter(function (a) {
                    return a.message && a.categories && a.categories.showinmenu
                }).map(function (a) {
                    a.message.quantities = a.message.quantities || {}
                    return _.extend({caption: a.title, icon: a.message.quantities.menuIcon}, a)
                }).uniq(s => s.message.systemId).value()
}
filterShowInMenuMessages._depends = {
    symbol : __symbolPrefix + "filterShowInMenuMessages",
    modules : [
        "_"
    ]
}

function mapAvailableGroupMessages (_, all) {
    return _(all).map(function (a) {
                a.message = a.message || {}
                a.message.quantities = a.message.quantities || {}
                return _.extend({caption: a.title, icon: a.message.quantities.menuIcon}, a)
            }).uniq(s => s.message.systemId).value()
}
mapAvailableGroupMessages._depends = {
    symbol : __symbolPrefix + "mapAvailableGroupMessages",
    modules : [
        "_"
    ]
}

function isMessageVisible(message) {
    if (!message) return false
    message = message.message || message

    if(message.noNeedValidTimeChecking){
        return true
    }

    var attr = message.ATTRIBUTES || {}
    if (new Date(attr.valueFrom || attr.validFrom) < Date.now() && new Date(attr.validTo) > Date.now()) {
        switch (attr.status) {
            case 'deleted':
                return false
            case 'redeemed':
                if(!message.quantities){
                    return true
                }

                var hideWhenRedeemed = message.quantities.hideWhenRedeemed
                if(typeof message.quantities.hideWhenRedeemed == "string"){
                    hideWhenRedeemed = message.quantities.hideWhenRedeemed == "true"
                }

                return !hideWhenRedeemed && !message.categories['spe:voucher']
            case 'read':
                if(!message.quantities){
                    return true
                }

                var hideWhenRead = message.quantities.hideWhenRead
                if(typeof message.quantities.hideWhenRead == "string"){
                    hideWhenRead = message.quantities.hideWhenRead == "true"
                }

                return !hideWhenRead
            default:
                return true
        }
    } else {
        return false
    }
    
}

isMessageVisible._depends = {
    symbol : __symbolPrefix + "isMessageVisible",
    modules : [
    ]
}

!(function (exports, ioc) {
    exports.hasCategory = hasCategory
    exports.groupsFromSchemeMessages = groupsFromSchemeMessages
    exports.groupIncludesMessage = groupIncludesMessage
    exports.rejectMessagesWithGroup = rejectMessagesWithGroup
    exports.passMessagesForHomepage = passMessagesForHomepage
    exports.sortAndDedupeForHomepage = sortAndDedupeForHomepage
    exports.partitionHomepageMessages = partitionHomepageMessages
    exports.initMapToType = initMapToType
    exports.getMessageButtons = getMessageButtons
    exports.getButtons = getButtons
    exports.pressButton = pressButton
    exports.press = press
    exports.spendPoints = spendPoints
    exports.language = language
    exports.filterShowInMenuMessages = filterShowInMenuMessages
    exports.mapAvailableGroupMessages = mapAvailableGroupMessages
    exports.isMessageVisible = isMessageVisible

    if (typeof window == "object" && window == this && ioc && typeof ioc.inject == "function") {
        !Object.keys(exports).forEach(function (key) {
            window[key] = ioc.inject(exports[key])
        })
    }
})(typeof exports == "object" ? exports : {}, typeof this.ioc != "undefined" ? this.ioc : null)

typeof exports
